module.exports = __webpack_public_path__ + "static/img/board1-EN.32eebb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/board1-EN.png
// module id = PYbl
// module chunks = 1